export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const NEW_NODE = 'NEW_NODE';
export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const OS_CONNECTION_START = 'OS_CONNECTION_START';
export const OS_CONNECTION_SUCCESS = 'OS_CONNECTION_SUCCESS';
export const OS_CONNECTION_FAILURE = 'OS_CONNECTION_FAILURE';

export const OS_CREATED_CONNECTION_START = 'OS_CREATED_CONNECTION_START';
export const OS_CREATED_CONNECTION_SUCCESS = 'OS_CREATED_CONNECTION_SUCCESS';
export const OS_CREATED_CONNECTION_FAILURE = 'OS_CREATED_CONNECTION_FAILURE';

export const DOMAIN_CONNECTION_START = 'DOMAIN_CONNECTION_START';
export const DOMAIN_CONNECTION_SUCCESS = 'DOMAIN_CONNECTION_SUCCESS';
export const DOMAIN_CONNECTION_FAILURE = 'DOMAIN_CONNECTION_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_APPS = 'CLEAR_APPS';
export const ADD_APPS_START = 'ADD_APPS_START';
export const ADD_APPS_SUCCESS = 'ADD_APPS_SUCCESS';
export const ADD_APPS_FAILURE = 'ADD_APPS_FAILURE';

export const REMOVE_APPS_START = 'REMOVE_APPS_START';
export const REMOVE_APPS_SUCCESS = 'REMOVE_APPS_SUCCESS';
export const REMOVE_APPS_FAILURE = 'REMOVE_APPS_FAILURE';

export const CLEAR_EXCLUDES = 'CLEAR_EXCLUDES';
export const ADD_EXCLUDES_START = 'ADD_EXCLUDES_START';
export const ADD_EXCLUDES_SUCCESS = 'ADD_EXCLUDES_SUCCESS';
export const ADD_EXCLUDES_FAILURE = 'ADD_EXCLUDES_FAILURE';

export const REMOVE_EXCLUDES_START = 'REMOVE_EXCLUDES_START';
export const REMOVE_EXCLUDES_SUCCESS = 'REMOVE_EXCLUDES_SUCCESS';
export const REMOVE_EXCLUDES_FAILURE = 'REMOVE_EXCLUDES_FAILURE';

export const SAML_NODES_SEARCH_START = 'SAML_NODES_SEARCH_START';
export const SAML_NODES_SEARCH_SUCCESS = 'SAML_NODES_SEARCH_SUCCESS';
export const SAML_NODES_SEARCH_FAILURE = 'SAML_NODES_SEARCH_FAILURE';

export const SAML_CERTIFICATE_DOWNLOAD_START = 'SAML_CERTIFICATE_DOWNLOAD_START';
export const SAML_CERTIFICATE_DOWNLOAD_SUCCESS = 'SAML_CERTIFICATE_DOWNLOAD_SUCCESS';
export const SAML_CERTIFICATE_DOWNLOAD_FAILURE = 'SAML_CERTIFICATE_DOWNLOAD_FAILURE';

export const SAML_CERTIFICATE_REISSUE_START = 'SAML_CERTIFICATE_REISSUE_START';
export const SAML_CERTIFICATE_REISSUE_SUCCESS = 'SAML_CERTIFICATE_REISSUE_SUCCESS';
export const SAML_CERTIFICATE_REISSUE_FAILURE = 'SAML_CERTIFICATE_REISSUE_FAILURE';

export const SAML_METADATA_DOWNLOAD_START = 'SAML_METADATA_DOWNLOAD_START';
export const SAML_METADATA_DOWNLOAD_SUCCESS = 'SAML_METADATA_DOWNLOAD_SUCCESS';
export const SAML_METADATA_DOWNLOAD_FAILURE = 'SAML_METADATA_DOWNLOAD_FAILURE';

export const SHOW_NEW_SAML_CERT_EXP_AT_START = 'SHOW_NEW_SAML_CERT_EXP_AT_START';
export const SHOW_NEW_SAML_CERT_EXP_AT_SUCCESS = 'SHOW_NEW_SAML_CERT_EXP_AT_SUCCESS';
export const SHOW_NEW_SAML_CERT_EXP_AT_FAILURE = 'SHOW_NEW_SAML_CERT_EXP_AT_FAILURE';

export const LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION_START =
    'LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION_START';
export const LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION_SUCCESS =
    'LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION_SUCCESS';
export const LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION_FAILURE =
    'LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
